import { Tag } from "@blueprintjs/core";
import * as React from "react";
import { SearchFilterKeys, SearchFilterProps, SearchFilterValue } from "../../utils/search";
import { HTMLAttributes } from "react";

type GenomeSearchTagsProps = HTMLAttributes<HTMLDivElement> & {
  inUseSearchFields: SearchFilterProps[];
  removeSearchFilter: (key: SearchFilterKeys, val: SearchFilterValue) => void;
};

const GenomeSearchTags = ({
  inUseSearchFields,
  removeSearchFilter,
  className,
}: GenomeSearchTagsProps) => {
  const displayTags = inUseSearchFields
    // Sequence search has its own textarea, we don't need to display it as a search tag
    .filter((tag) => tag.key !== "sequence")
    .map((tag) => {
      return (
        <Tag
          onRemove={(_e) => removeSearchFilter(tag.key, tag.val)}
          className="search-tag"
          key={`search-key-${tag.key}-${tag.val}`}
        >
          {`${tag.title}: ${tag.val}`}
        </Tag>
      );
    });

  return displayTags.length > 0 ? (
    <div className={className}>
      <span>{displayTags}</span>
    </div>
  ) : null;
};

export default GenomeSearchTags;
